import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';
import { backgroundColorOptions } from '../base/utils';
import media from '../base/media';

export const Wrapper = styled.div`
	position: relative;
	min-height: 36rem;
	padding: 4rem;
	box-shadow: 0 7px 17px 0 rgba(147,94,196,0.1);
	background-color: #fff;
	transition: transform 250ms ease, box-shadow 250ms ease;

	${media.desktopLarge`
		padding: 5rem;
		padding-right: 20rem;
	`}

	&:hover {
		transform: translate3d(0, -1px, 0);
		box-shadow: 0 8px 20px 0 rgba(147,94,196,0.15);
	}
`;

export const Line = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	height: 0.6rem;
	${backgroundColorOptions};
`;

export const Link = styled(RouterLink)`
	display: block;
	margin-bottom: 0.7rem;
	color: ${({ theme }) => theme.colors.gray};
	transition: color 150ms ease;

	&:hover {
		color: ${({ theme }) => theme.colors.primary};
	}
`;

export const Image = styled.img`
	display: none;
	position: absolute;
	right: 5rem;
	top: 5rem;

	${media.desktopLarge`
		display: block;
	`};
`;
